import React from 'react'
import Button from '../../../../../../common/components/atom/Button/Button'
import { PermissionTooltip, useCapability } from '../../../../../rbac'

export default function PlanBTAddButtonPresenter() {
  const canEdit = useCapability('planbt.edit')
  return (
    <PermissionTooltip allowed={canEdit}>
      <Button onClick={() => {}} disabled={!canEdit} linkTo={'/main/plan-bt/create'}  label='Créer un plan' iconRightType={'plus'} />
    </PermissionTooltip>
  )
}
